/**
 * 自前検索（説明文/SKU/タイトル/タグの部分一致・日本語対応）＋ ページ送り。
 * 結果は /search ページ内にテーマ(Prestige)の product-list / product-card と同じ
 * マークアップで描画し、標準(S&D)の結果は継続的に非表示にする。
 *
 * 組み込み (theme.liquid の </body> 直前):
 *   <script>
 *     window.RC_SEARCH_MAP_URL   = "{{ 'rc-search-map.json'   | asset_url }}";
 *     window.RC_SEARCH_INDEX_URL = "{{ 'rc-search-index.json' | asset_url }}";
 *   </script>
 *   <script src="{{ 'rc-search.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var MAP_URL   = window.RC_SEARCH_MAP_URL;
  var INDEX_URL = window.RC_SEARCH_INDEX_URL;
  var PATTERN   = window.RC_SEARCH_PATTERN ? new RegExp(window.RC_SEARCH_PATTERN) : /^IT[A-Z0-9]{8,}$/;
  var PER_PAGE  = window.RC_SEARCH_PER_PAGE || 36;
  var CURRENCY  = (window.RC_CURRENCY_PREFIX != null) ? window.RC_CURRENCY_PREFIX : '¥';
  var LAYOUT    = window.RC_LIST_LAYOUT || 'medium';
  var IMG_W     = window.RC_IMAGE_WIDTH || 600;
  var SORT      = window.RC_SORT || 'new'; // 'new'=新着順 / 'relevance'=関連度順
  var NEW_DAYS  = window.RC_NEW_DAYS || 20;  // 公開から何日以内をNEW扱いにするか
  // 店舗ラベル（product-card.liquid の collections-container と同じ見た目・同じ判定）
  //   上から順に判定し、最初に当てはまった1つだけを表示する（1商品にラベルは1つ）
  //   collection: 所属していれば表示（GASのLABEL_COLLECTIONSのタイトルを小文字にしたもの）
  //   fallback: true のラベルは、それより上のどれにも当てはまらなかったときに表示
  //   url: 指定するとコレクションへのリンク付きで表示
  var STORE_LABELS = window.RC_STORE_LABELS || [
    { label: 'YOKOHAMA', cls: '',         collection: 'yokohama', url: '/collections/yokohama' },
    { label: 'GINZA',    cls: 'ginzatag', collection: 'ginza',    url: '/collections/ginza', fallback: true }
  ];
  var COLS_D    = window.RC_COLS_DESKTOP || 4; // PCの列数
  var COLS_T    = window.RC_COLS_TABLET  || 3; // タブレットの列数
  var COLS_M    = window.RC_COLS_MOBILE  || 2; // スマホの列数
  var SEARCH_SECTION = window.RC_SEARCH_SECTION || '.shopify-section--main-search'; // 差し込み先
  var GUTTER    = window.RC_CONTENT_GUTTER || 'clamp(16px, 4vw, 64px)'; // 左右の余白
  var HIDE_SELECTORS = window.RC_HIDE_SELECTORS || 'product-list, .product-list, .pagination, .facets-sidebar, .empty-state, [part="tab-list-scrollable"], .main-search__resource-item, .main-search';
  var MOUNT_SEL = window.RC_MOUNT_SELECTOR || '';

  var mapPromise = null, dataPromise = null;
  var lastResults = [], lastTerm = '';
  var nativeObserver = null, lastHidden = -1;

  // ---- データ ----
  function loadMap() {
    if (!mapPromise) {
      mapPromise = fetch(MAP_URL, { cache: 'no-cache' })
        .then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
    }
    return mapPromise;
  }
  function loadData() {
    if (!dataPromise) {
      dataPromise = fetch(INDEX_URL, { cache: 'no-cache' })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (json) {
          return (json || []).map(function (r) {
            return {
              h: r.h, handle: (r.h || '').replace('/products/', ''),
              t: r.t || '', p: r.p, img: r.img || '',
              _title: (r.t || '').toLowerCase(),
              _sku: ((r.s || '') + ' ' + (r.n || '')).toLowerCase(),
              _date: (typeof r.c === 'number') ? r.c : (r.c ? (Date.parse(r.c) || 0) : 0),
              _avail: r.a ? 1 : 0,
              _tags: String(r.g || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean),
              _cols: (Array.isArray(r.k) ? r.k : []).map(function (x) { return String(x).toLowerCase(); }),
              _blob: [r.t, r.n, r.s, r.v, r.y, r.g, r.d].join(' ').toLowerCase()
            };
          });
        }).catch(function () { return []; });
    }
    return dataPromise;
  }

  function normUpper(s) { return (s || '').trim().toUpperCase(); }
  function isLookupTerm(t) { return !!t && PATTERN.test(t); }

  function searchAll(rawTerm, data) {
    var q = (rawTerm || '').trim().toLowerCase();
    if (!q) return [];
    var terms = q.split(/\s+/).filter(Boolean);
    var out = [];
    for (var i = 0; i < data.length; i++) {
      var d = data[i], ok = true;
      for (var j = 0; j < terms.length; j++) { if (d._blob.indexOf(terms[j]) < 0) { ok = false; break; } }
      if (!ok) continue;
      var score = 0;
      if (d._title.indexOf(q) >= 0) score += 100;
      if (d._sku.indexOf(q) >= 0) score += 80;
      for (var k = 0; k < terms.length; k++) {
        if (d._title.indexOf(terms[k]) >= 0) score += 10;
        else if (d._sku.indexOf(terms[k]) >= 0) score += 6;
        else score += 1;
      }
      out.push({ d: d, score: score });
    }
    out.sort(function (a, b) {
      if (a.d._avail !== b.d._avail) return b.d._avail - a.d._avail; // 在庫ありを上に
      if (SORT === 'relevance') return b.score - a.score || a.d.t.length - b.d.t.length;
      return (b.d._date - a.d._date) || (b.score - a.score); // 新着順（同日付は関連度順）
    });
    return out.map(function (x) { return x.d; });
  }

  // ---- 標準(S&D)結果を継続的に隠す ----
  function hideNativeAll() {
    var root = document.getElementById('rc-results');
    var count = 0;
    try {
      document.querySelectorAll(HIDE_SELECTORS).forEach(function (el) {
        if (root && (el === root || root.contains(el))) return; // 自前結果は除外
        if (el.style.display !== 'none') { el.style.display = 'none'; }
        count++;
      });
    } catch (e) { if (console) console.warn('[rc-search] hide error', e); }
    if (count !== lastHidden) {
      lastHidden = count;
      if (console && console.info) console.info('[rc-search] 標準結果を非表示にした要素数:', count);
    }
  }
  function watchNative() {
    if (nativeObserver) return;
    nativeObserver = new MutationObserver(function () { hideNativeAll(); });
    nativeObserver.observe(document.documentElement, { childList: true, subtree: true });
    [100, 400, 1000, 2500, 5000].forEach(function (ms) { setTimeout(hideNativeAll, ms); });
  }

  // ---- 描画 ----
  function injectStyleOnce() {
    if (document.getElementById('rc-style')) return;
    var st = document.createElement('style');
    st.id = 'rc-style';
    st.textContent = [
      '#rc-results{margin:24px 0 48px;padding:0 ' + GUTTER + ';box-sizing:border-box;}',
      '#rc-results .rc-head{font-size:15px;color:#555;margin:0 0 18px;}',
      '#rc-results .rc-empty{padding:30px 0;color:#666;}',
      '#rc-results .product-card{opacity:1;}',                    /* reveal-on-scroll対策 */
      '#rc-results .product-list{display:grid !important;grid-template-columns:repeat(' + COLS_D + ',minmax(0,1fr)) !important;}',
      '@media (max-width:999px){#rc-results .product-list{grid-template-columns:repeat(' + COLS_T + ',minmax(0,1fr)) !important;}}',
      '@media (max-width:699px){#rc-results .product-list{grid-template-columns:repeat(' + COLS_M + ',minmax(0,1fr)) !important;}}',
      '#rc-results .rc-pager-wrap{display:flex;justify-content:center;margin-top:34px;}'
    ].join('');
    document.head.appendChild(st);
  }

  function getMount() {
    if (MOUNT_SEL) { var m = document.querySelector(MOUNT_SEL); if (m) return m; }
    var cands = ['#MainContent', 'main', '[role="main"]', '.main-content', '#main'];
    for (var i = 0; i < cands.length; i++) { var el = document.querySelector(cands[i]); if (el) return el; }
    return document.body;
  }

  function ensureRoot() {
    var root = document.getElementById('rc-results');
    if (root) return root;
    injectStyleOnce();
    root = document.createElement('div');
    root.id = 'rc-results';
    var section = document.querySelector(SEARCH_SECTION);
    if (section) { section.appendChild(root); }              // 検索セクション内に統一して差し込む
    else {
      var anchor = document.querySelector('product-list, .product-list');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor);
      else { var mount = getMount(); mount.insertBefore(root, mount.firstChild); }
    }
    return root;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function imgUrl(src) { return src ? src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + IMG_W : ''; }
  function priceHtml(p, avail) {
    if (!avail) {
      // 売り切れはテーマに合わせて ¥0 を薄く表示
      return '<price-list class="price-list"><sale-price class="h6 text-subdued" style="color:#999;opacity:.7;">' +
             '¥0<span class="taxin" style="color:#999;opacity:.7;"> （税込）</span></sale-price></price-list>';
    }
    if (p === '' || p == null) return '';
    var n = Number(p); if (isNaN(n)) return '';
    var s = CURRENCY + Math.round(n).toLocaleString();
    return '<price-list class="price-list"><sale-price class="h6 text-subdued">' +
           escapeHtml(s) + '<span class="taxin"> （税込）</span></sale-price></price-list>';
  }
  // 店舗ラベル（YOKOHAMA / GINZA）。1商品につき1つだけ。該当がなければ空文字
  function tagLabelsHtml(d) {
    var picked = null;
    for (var i = 0; i < STORE_LABELS.length; i++) {
      var L = STORE_LABELS[i];
      var byTag = L.tag && d._tags.indexOf(String(L.tag).toLowerCase()) >= 0;
      var byCol = L.collection && d._cols.indexOf(String(L.collection).toLowerCase()) >= 0;
      if (byTag || byCol || L.fallback) { picked = L; break; }
    }
    if (!picked) return '';
    var cls = 'single-collection' + (picked.cls ? ' ' + escapeHtml(picked.cls) : '');
    var inner = escapeHtml(picked.label);
    if (picked.url) {
      inner = '<a href="' + escapeHtml(picked.url) + '" title="' + escapeHtml(picked.label) + '">' +
              escapeHtml(picked.label) + '</a>';
    }
    return '<div class="collections-container"><div class="' + cls + '">' + inner + '</div></div>';
  }

  function cardHtml(d) {
    var url = escapeHtml(d.h), title = escapeHtml(d.t);
    var isNew = d._date && (Date.now() - d._date) <= NEW_DAYS * 86400000;
    var newBadge = isNew ? '<span class="product_newlabel">NEW</span>' : '';
    var tagBadges = tagLabelsHtml(d);
    var soldBadge = d._avail ? ''
      : '<badge-list class="badge-list badge-list--vertical"><sold-out-badge class="badge badge--sold-out">SOLD</sold-out-badge></badge-list>';
    var media = d.img
      ? '<a href="' + url + '" class="product-card__media" data-instant><img src="' + escapeHtml(imgUrl(d.img)) +
        '" alt="' + title + '" loading="lazy" class="product-card__image product-card__image--primary aspect-natural"></a>'
      : '<a href="' + url + '" class="product-card__media" data-instant></a>';
    return '<product-card class="product-card" handle="' + escapeHtml(d.handle) + '">' +
             '<div class="product-card__figure">' + newBadge + tagBadges + soldBadge + media + '</div>' +
             '<div class="product-card__info empty:hidden"><div class="v-stack justify-items-center gap-2">' +
               '<div class="v-stack justify-items-center gap-1">' +
                 '<a href="' + url + '" class="product-title h6" data-instant>' + title + '</a>' +
                 priceHtml(d.p, d._avail) +
               '</div></div></div>' +
           '</product-card>';
  }

  // ---- ページネーション（テーマの pagination をそのまま使い、外側で中央寄せ） ----
  function pageHref(n) { return '/search?page=' + n + '&q=' + encodeURIComponent(lastTerm); }
  function chevron(dir) {
    var cls = dir === 'next' ? 'icon-chevron-right' : 'icon-chevron-left';
    var path = dir === 'next' ? 'm3 9 4-4-4-4' : 'm7 1-4 4 4 4';
    return '<svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon ' + cls +
           ' icon--direction-aware" viewBox="0 0 10 10"><path d="' + path +
           '" stroke="currentColor" stroke-linecap="square"/></svg>';
  }
  function linkA(n, inner, extra) {
    return '<a class="pagination__link h6" ' + (extra || '') + ' data-rc-page="' + n +
           '" href="' + escapeHtml(pageHref(n)) + '">' + inner + '</a>';
  }
  function dotSpan() { return '<span class="pagination__link pagination__link--disabled h6">&hellip;</span>'; }

  function pagerHtml(page, totalPages) {
    if (totalPages <= 1) return '';
    var out = '<nav class="pagination" role="navigation" aria-label="ページネーション">';
    if (page > 1) out += linkA(page - 1, chevron('prev'), 'rel="prev" aria-label="前のページ"');
    var start = Math.max(1, page - 2), end = Math.min(totalPages, page + 2);
    if (start > 1) { out += linkA(1, '1'); if (start > 2) out += dotSpan(); }
    for (var n = start; n <= end; n++) {
      if (n === page) out += '<span class="pagination__link pagination__link--disabled h6" aria-current="page">' + n + '</span>';
      else out += linkA(n, String(n));
    }
    if (end < totalPages) { if (end < totalPages - 1) out += dotSpan(); out += linkA(totalPages, String(totalPages)); }
    if (page < totalPages) out += linkA(page + 1, chevron('next'), 'rel="next" aria-label="次のページ"');
    return '<div class="rc-pager-wrap">' + out + '</nav></div>';
  }

  function currentPage() {
    var p = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
    return (isNaN(p) || p < 1) ? 1 : p;
  }
  function goPage(n) {
    var u = new URL(location.href);
    u.searchParams.set('page', n);
    history.pushState({ rcPage: n }, '', u.toString());
    render();
    var root = document.getElementById('rc-results');
    if (root) window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
  }
  window.addEventListener('popstate', function () { if (lastResults.length || lastTerm) render(); });

  function render() {
    var root = ensureRoot();
    var total = lastResults.length;
    var totalPages = Math.max(1, Math.ceil(total / PER_PAGE));
    var page = Math.min(currentPage(), totalPages);
    var slice = lastResults.slice((page - 1) * PER_PAGE, page * PER_PAGE);

    var head = '<p class="rc-head">「' + escapeHtml(lastTerm) + '」の検索結果 ' + total + '件' +
               (totalPages > 1 ? '（' + page + '/' + totalPages + 'ページ）' : '') + '</p>';
    var body;
    if (!total) {
      body = '<div class="rc-empty">該当する商品が見つかりませんでした。</div>';
    } else {
      body = '<product-list class="product-list" collection-mobile-layout="' + LAYOUT +
             '" collection-desktop-layout="' + LAYOUT + '">' +
             slice.map(cardHtml).join('') + '</product-list>' + pagerHtml(page, totalPages);
    }
    root.innerHTML = head + body;
    root.querySelectorAll('[data-rc-page]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var n = parseInt(a.getAttribute('data-rc-page'), 10);
        if (!isNaN(n)) goPage(n);
      });
    });
    hideNativeAll();
  }

  function runOnSearchPage() {
    if (!/\/search$/.test(location.pathname.replace(/\/$/, ''))) return;
    var q = new URLSearchParams(location.search).get('q') || '';
    if (!q) return;
    if (console && console.info) console.info('[rc-search] 検索ページで起動 q=', q);
    lastTerm = q;
    ensureRoot().innerHTML = '<p class="rc-head">検索中…</p>';
    hideNativeAll();
    watchNative();
    loadData().then(function (data) { lastResults = searchAll(q, data); render(); });
  }

  // ---- 検索ボックスの送信 ----
  function handleSubmit(rawTerm) {
    if (!rawTerm || !rawTerm.trim()) return;
    var term = normUpper(rawTerm);
    if (isLookupTerm(term)) {
      loadMap().then(function (map) {
        if (map && Object.prototype.hasOwnProperty.call(map, term)) window.location.href = map[term];
        else window.location.href = '/search?q=' + encodeURIComponent(rawTerm);
      });
    } else {
      window.location.href = '/search?q=' + encodeURIComponent(rawTerm);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.isComposing || e.keyCode === 229) return;
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[name="q"]')) return;
    if (!input.value || !input.value.trim()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    handleSubmit(input.value);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value || !input.value.trim()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    handleSubmit(input.value);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="q"]')) { loadMap(); loadData(); }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runOnSearchPage);
  else runOnSearchPage();
})();